import { render, staticRenderFns } from "./NavBarV.vue?vue&type=template&id=95aa2632&scoped=true"
import script from "./NavBarV.vue?vue&type=script&lang=js"
export * from "./NavBarV.vue?vue&type=script&lang=js"
import style0 from "./NavBarV.vue?vue&type=style&index=0&id=95aa2632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa2632",
  null
  
)

export default component.exports